module.exports = __webpack_public_path__ + "img/bzhan.118ba274.png";